import apiClient from '@/services/api';

const API_URL = '/countries';

const sanitizeCountryData = (countryData) => {
  const data = { ...countryData };
  data.phone_code = data.phone_code ? parseInt(data.phone_code) : 0;
  return data;
};

export default {
  async getCountries() { const r = await apiClient.get(API_URL); return r.data; },
  async getCountry(id) { const r = await apiClient.get(`${API_URL}/${id}`); return r.data; },
  async createCountry(data) { const r = await apiClient.post(API_URL, sanitizeCountryData(data)); return r.data; },
  async updateCountry(id, data) { const r = await apiClient.put(`${API_URL}/${id}`, sanitizeCountryData(data)); return r.data; },
  async deleteCountry(id) { return apiClient.delete(`${API_URL}/${id}`); }
};

// class Country(db.Model):
//     __tablename__ = 'countries'
//     id: Mapped[int] = mapped_column(BIGINT, primary_key=True)
//     country_code: Mapped[str] = mapped_column(String(3), nullable=False)
//     country_name: Mapped[str] = mapped_column(String(255), nullable=False)
//     phone_code: Mapped[str] = mapped_column(String(10), nullable=False)

//     def to_dict(self):
//         return {
//             'id': self.id,
//             'country_code': self.country_code,
//             'country_name': self.country_name,
//             'phone_code': self.phone_code
//         }